export default __webpack_public_path__ + "images/delete-circle-icon.svg";